export default [
  {
    path: "/mobile/request-letter/:token",
    name: "mobile.request.letter.upload",
    component: () => import("@/pages/frontend/requestletterupload")
  }
];
